import useFetchLatestPomelloVersion from '@api/useFetchLatestPomelloVersion';
import Placeholder from '@components/Placeholder';
import Translate from '@components/Translate';
import useTranslation from '@helpers/useTranslation';
import React, { FC, Fragment } from 'react';

const CurrentPomelloVersion: FC = () => {
  const { t } = useTranslation();

  const { data: version } = useFetchLatestPomelloVersion();

  return (
    <p>
      <Translate
        components={{
          // eslint-disable-next-line jsx-a11y/anchor-has-content
          changelogLink: <a href="https://trello.com/b/aLvdAXsh/pomello-development/" />,
          version: version ? <Fragment /> : <Placeholder />,
        }}
        message={t('currentVersion', { version: version ?? '0.00.0' })}
      />
    </p>
  );
};

export default CurrentPomelloVersion;
